import React  from 'react'
import styled from 'styled-components'
import { Back, BackBlack, Next, NextBlack } from 'assets/icons'

export class Button extends React.Component {
  handlePayloadClick = (e) => {
    const {type, text, value, onButtonClick} = this.props

    if (onButtonClick) {
      onButtonClick({type, text, value})
    }
  }

  render() {
    const { text } = this.props
    return <BtnContainer onClick={this.handlePayloadClick} role="listitem">{text}</BtnContainer>
  }
}

const BtnContainer = styled.button`
  background: ${props => props.theme.primaryColor};
  color: ${props => props.theme.secondaryColor};
  padding: 10px;
  width: 100%;
  opacity: 1;
  cursor: pointer;
  margin-top: 5px;
  border-radius: 5px;
  opacity: 1;
  font-size: 14px;
  font-weight: bold;

  &:hover {
    opacity: 0.9;
  }
`

export class NextButton extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    this.props.nextSlide()
  };

  render() {
    const hide =
      this.props.currentSlide + this.props.slidesToScroll >=
      this.props.slideCount && !this.props.wrapAround

    const next = this.props.theme.primaryColorContrastColor === '#101010' ? NextBlack : Next

    return hide ? null : (
      <BtnNavCarousel
        onClick={this.handleClick}
      >
        <img src={next} alt="next question" height={15} style={{marginLeft: '3px'}} />
      </BtnNavCarousel>
    )
  }
}


export class PreviousButton extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    this.props.previousSlide()
  };

  render() {
    const back = this.props.theme.primaryColorContrastColor === '#101010' ? BackBlack : Back

    const hide =
      (this.props.currentSlide === 0 && !this.props.wrapAround) ||
      this.props.slideCount === 0
    return hide ? null : (
      <BtnNavCarousel
        onClick={this.handleClick}
      >
        <img src={back} alt="previous question" height={15} style={{marginLeft: '1px', marginRight: '2px'}} />
      </BtnNavCarousel>
    )
  }
}


const BtnNavCarousel = styled.button`
  border: none;
  background: var(--clr-bot-main, ${props => props.theme.primaryColor});
  color: var(--clr-text-on-button, white);
  padding: 12px 10px 10px 10px;
  opacity: 0.7;
  cursor: pointer;
  border-radius: 5px;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Carousel/Buttons.js